export default {
  align: {
    type: 'string',
    default: 'full',
  },
  title: {
    type: 'string',
    default: '',
  },
  buttonText: {
    type: 'string',
    default: '',
  },
  cardTitle: {
    type: 'string',
    default: '',
  },
  linkButton: {
    type: 'string',
    default: '',
  },
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
};
